export default "__VITE_ASSET__8MICL7QL__"